import { RoundButton } from '@cian/ui-kit';
import { useDeviceType } from '@cian/ui-kit/responsive';
import { IconActionMore16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

import { ETestId } from '../../constants/testId';

interface IGalleryMoreButtonProps {
  onClick?(): void;
}

export const GalleryMoreButton = React.forwardRef<HTMLButtonElement, IGalleryMoreButtonProps>(({ onClick }, ref) => {
  const deviceType = useDeviceType();
  const isMobile = deviceType === 'phone';

  return (
    <RoundButton
      ref={ref}
      theme="fill_dark"
      size={isMobile ? 'M' : 'XS'}
      onClick={onClick}
      title="Еще"
      icon={<IconActionMore16 color="white_100" aria-label="more" display="block" />}
      data-testid={ETestId.GalleryMoreButton}
    />
  );
});

GalleryMoreButton.displayName = 'GalleryMoreButton';
